<div class="mb-4" style="box-shadow: none">
  <div class="card-header" style="border: 1px solid #e4e4e4; position: relative">
    <app-input type="select" [formControl]="installmentsPlanTypeGroupsControl" appearance="fill" multiple
               fullWidth="false" [label]="'PAYMENTS.list.filters.payment_plan_type.label' | translate"
               [selectOptions]="paymentPlanTypeGroups" [selectLabel]="'label'" [selectValue]="'value'"
               [showClear]="false"
               style="position: absolute; left: 10px; top: 0" [hidden]="componentType === 'distribution'">
    </app-input>
    <h1 class="text-center m-0">{{ "CASES.single.upcoming-payments" | translate }}</h1>
    <div style="position: absolute; right: 10px; top: 20px">
      <mat-slide-toggle color="primary" (change)="this.showHideUnpaid($event)">
        {{ "PAYMENTS.show-only-unpaid" | translate }}
      </mat-slide-toggle>
    </div>
  </div>
  <!--Bulk actions -->
  <button mat-raised-button color="primary" class="mb-2"
          [disabled]="!isElementRestricted()"
          [matMenuTriggerFor]="bulkActions" [ngClass]="{'mt-4': selectionPaymentsDisabled}">
    {{ "SHARED.bulk-actions" | translate }}
  </button>
  <mat-menu #bulkActions="matMenu">
    <!--Delete -->
    <div [title]="selectionPaymentsDisabled ? 'One or more selected payments does not have this action available' : ''">
      <a mat-menu-item class="dropdown-item" href="#" [disabled]="selectionPaymentsDisabled"
         (click)="deletePayment($event, selectionInstallments)">
        Delete
      </a>
    </div>
    <a mat-menu-item class="dropdown-item" href="#" [disabled]="selectionPaymentsDisabled"
       (click)="mergeInstallments(selectionInstallments)">
      Merge
    </a>
  </mat-menu>

  <div class="card-body p-0">

    <div class="mat-elevation-z8" style="border: 1px solid rgba(0, 0, 0, 0.12); border-top: none">
      <table style="width: 100%" mat-table matSort (matSortChange)="sortData($event)"
             [dataSource]="showOnlyUnpaid ? dataSourceUnpaid : dataSource" multiTemplateDataRows>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle(selectionInstallments, showOnlyUnpaid ? dataSourceUnpaid : dataSource) : null"
              color="primary"
              [checked]="selectionInstallments.hasValue() && isAllSelected(selectionInstallments, showOnlyUnpaid ? dataSourceUnpaid : dataSource)"
              [indeterminate]="selectionInstallments.hasValue() && !isAllSelected(selectionInstallments, showOnlyUnpaid ? dataSourceUnpaid : dataSource)">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" color="primary"
                          (change)="$event ? selectionInstallments.toggle(row) : null"
                          [checked]="selectionInstallments.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="client-name">
          <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.name" | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{
              element.case.client.first_name + ' ' +
              element.case.client.last_name
            }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.email" | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{element.case.client.email}} </td>
        </ng-container> -->

        <ng-container matColumnDef="next-payment">
          <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.payment-schedule" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.active">
              <span>{{ element.term_date | toDateObject | date }}</span>
              <p class="m-0" style="color: red"
                 *ngIf="element.amount_paid < element.amount && (element.term_date | toDateObject) < now">
                <small>{{ "PAYMENTS.missed-payment" | translate }}</small>
              </p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="date-paid">
          <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.date-paid" | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.date_paid | toDateObject | date }}
            <ng-container *ngIf="element.date_paid">
              <p class="m-0" style="color: green" *ngIf="element.amount_paid === element.amount">
                <small>{{ "PAYMENTS.paid" | translate }}</small>
              </p>
              <p class="m-0" style="color: orange"
                 *ngIf="element.amount_paid < element.amount && element.amount_paid > 0">
                <small>{{ "PAYMENTS.partial-paid" | translate }}</small>
              </p>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.amount" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <small class="font-weight-lighter">{{ element.amount_paid | number: '1.2-2' }}€
              / {{ element.amount | number: '1.2-2' }}€ </small>
            <span class="font-weight-bold">- {{ element.amount - element.amount_paid | number: '1.2-2' }}€</span>
            <div class="progress" style="max-width: 120px">
              <div class="progress-bar progress-bar-striped" role="progressbar"
                   [style]="{width: getPercent(element.amount_paid, element.amount)  + '%'}"
                   [attr.aria-valuenow]="getPercent(element.amount_paid, element.amount)"
                   [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">{{
                  getPercent(element.amount_paid,
                    element.amount)
                }}%
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ "SHARED.actions" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <button *ngIf="element.active" mat-stroked-button [matMenuTriggerFor]="menu"
                    [disabled]="!isElementRestricted()">
              {{ "SHARED.actions" | translate }}
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item class="dropdown-item" (click)="saveTermId(element)">
                {{ 'PAYMENTS.change-date' | translate }}
              </button>
              <button *ngIf="element.case_payment_plan?.type?.default" mat-menu-item class="dropdown-item"
                      (click)="openChangeAmountModal(element)">
                {{ 'PAYMENTS.change-value' | translate }}
              </button>
              <button *ngIf="!element.case_payment_plan?.type?.default" mat-menu-item class="dropdown-item"
                      (click)="openAdditionalAmountEditorModal(element)">
                {{ 'PAYMENTS.change-additional-value' | translate }}
              </button>
              <a *ngIf="authUser.role_id === 5 &&
               (element.case_payment_plan?.type?.default && element.amount_paid === 0)"
                 mat-menu-item class="dropdown-item clickable" (click)="deleteInstallment(element.id)">
                {{ 'CASES.single.payments.installment_list.table.actions.delete' | translate }}
              </a>
              <a *ngIf="authUser.role_id === 5 &&
               (element.case_payment_plan?.type?.default && element.amount > 0 && (element.amount !== element.amount_paid))"
                 mat-menu-item class="dropdown-item clickable" (click)="markAsPromo(element)">
                {{ 'CASES.single.payments.installment_list.table.actions.mark_as_promo' | translate }}
              </a>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "PAYMENTS.label" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <!--{{ element.name.includes('Phase 1') ? ('DISTRIBUTION.installments.phase1' | translate) : ('DISTRIBUTION.installments.phase2' | translate) }}<br>-->
            {{ element.case_payment_plan.type.default && element.name.includes('Phase 1') ? 'Setup' : element.case_payment_plan.type.name }}
            <br>
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="newColSeparator">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" [ngClass]="'custom-column'"></td>
        </ng-container>

        <!-- *ngIf="element.name.includes('Phase 2');" -->
        <ng-container matColumnDef="dist-schedule">
          <th mat-header-cell mat-sort-header
              *matHeaderCellDef>{{ "DISTRIBUTION.installments.dist_schedule" | translate }}
          </th>
          <ng-container *matCellDef="let element">
            <ng-container *ngIf="!element.name.includes('Phase 1'); else emptyCell">
              <td mat-cell [ngClass]="'custom-column'"
                  (click)="expandedElement = expandedElement === element ? null : element">
                {{ element.distribution_schedule | toDateObject | date }}
              </td>
            </ng-container>
            <ng-template #emptyCell>
              <td mat-cell [ngClass]="'custom-column'"></td>
              <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
            </ng-template>
          </ng-container>
        </ng-container>

        <!-- *ngIf="element.name.includes('Phase 2');" -->
        <ng-container matColumnDef="dist-paid">
          <th mat-header-cell mat-sort-header
              *matHeaderCellDef>{{ "DISTRIBUTION.installments.dist_date_paid" | translate }}
          </th>
          <ng-container *matCellDef="let element">
            <ng-container *ngIf="!element.name.includes('Phase 1'); else emptyCell">
              <td mat-cell [ngClass]="'custom-column'"
                  (click)="expandedElement = expandedElement === element ? null : element">
            <span *ngIf="element.disbursed_at; else pending">
              {{ element.disbursed_at | toDateObject | date }}
            </span>
                <ng-template #pending>not-disbursed</ng-template>
              </td>
            </ng-container>
            <ng-template #emptyCell>
              <td mat-cell [ngClass]="'custom-column'"></td>
              <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
            </ng-template>
          </ng-container>
        </ng-container>


        <!-- Header row first group -->
        <ng-container matColumnDef="header-row-first-group">
          <th mat-header-cell *matHeaderCellDef
              colspan="8" style="text-align: center;">
            {{ "DISTRIBUTION.installments.dist_pay_plan" | translate }}
          </th>
        </ng-container>


        <!-- Header row second group -->
        <ng-container matColumnDef="header-row-second-group">
          <th mat-header-cell *matHeaderCellDef
              colspan="5" style="text-align: center;">
            {{ "DISTRIBUTION.installments.dist_plan" | translate }}
          </th>
        </ng-container>

        <ng-container matColumnDef="amountDistributed">
          <th mat-header-cell *matHeaderCellDef>{{ "DISTRIBUTION.installments.dist_amt_distributed" | translate }}</th>
          <ng-container *matCellDef="let element">
            <ng-container *ngIf="!element.name.includes('Phase 1'); else emptyCell">
              <td mat-cell [ngClass]="'custom-column'"
                  (click)="expandedElement = expandedElement === element ? null : element">
                <small class="font-weight-lighter">{{ element.total_disbursed_amount | number: '1.2-2' }}€
                  / {{ (element.offer_to_creditors_total + element.distribution_fee) | number: '1.2-2' }} €</small>
                <span
                  class="font-weight-bold">- {{ element.offer_to_creditors_total + element.distribution_fee - element.total_disbursed_amount | number: '1.2-2' }}
                  €</span>
                <div class="progress" style="max-width: 120px">
                  <div class="progress-bar progress-bar-striped" role="progressbar"
                       [style]="{width: getPercent(element.total_disbursed_amount,element.offer_to_creditors_total+element.distribution_fee) + '%'}"
                       [attr.aria-valuenow]="getPercent(element.total_disbursed_amount,element.offer_to_creditors_total+element.distribution_fee)"
                       [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
                    {{
                      getPercent(
                        element.total_disbursed_amount,
                        element.offer_to_creditors_total + element.distribution_fee
                      )
                    }}%
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-template #emptyCell>
              <td mat-cell [ngClass]="'custom-column'"></td>
              <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
            </ng-template>
          </ng-container>
        </ng-container>
        <!-- <ng-container matColumnDef="showDistribution">
          <th mat-header-cell *matHeaderCellDef>distribution plan</th>
          <td mat-cell *matCellDef="let element" [ngClass]="'custom-column'">
            <button *ngIf="element.active" mat-stroked-button (click)="expandedElement = expandedElement === element ? null : element">
              show
            </button>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="showDistribution">
          <th mat-header-cell *matHeaderCellDef></th>
          <ng-container *matCellDef="let element">
            <ng-container *ngIf="!element.name.includes('Phase 1'); else emptyCell">
              <td mat-cell [ngClass]="'custom-column'">
                <!--<button *ngIf="element.total_distributed_amount > 0" mat-icon-button (click)="expandedElement = expandedElement === element ? null : element">-->
                <button mat-icon-button (click)="expandedElement = expandedElement === element ? null : element">
                  <mat-icon>more_vert</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-template #emptyCell>
              <td mat-cell [ngClass]="'custom-column'"></td>
              <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
            </ng-template>
          </ng-container>
        </ng-container>

        <!--<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>-->

        <ng-container *ngIf="isPhaseOne()||isPhaseTwo()">
          <tr mat-header-row *matHeaderRowDef="['header-row-first-group', 'header-row-second-group']"></tr>
        </ng-container>

        <!--<ng-container *ngIf="case?.product?.slug !== 'ds' && case?.product?.slug !== 'refinance'"-->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <!-- *ngIf="element.total_distributed_amount > 0" -->
              <ng-container>

                <div *ngIf="case.product.slug !== 'ds' && case.product.slug !== 'refinance'" class="table-container"
                     style="width: auto; margin-bottom: 16px; margin-top: 16px; margin-left: 55%;">
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th colspan="3"
                          class="table-title">{{ element.name.includes('Phase 1') ? ('DISTRIBUTION.installments.phase1' | translate) : ('DISTRIBUTION.installments.phase2' | translate) }}
                      </th>
                    </tr>
                    </thead>
                    <thead>
                    <tr>
                      <th>{{ "DISTRIBUTION.installments.dist_creditor" | translate }}</th>
                      <th>{{ "DISTRIBUTION.installments.dist_distributed" | translate }}</th>
                      <th>On Account</th>
                    </tr>
                    </thead>
                    <tbody>

                    <ng-container *ngIf="hasDistributionCaseTerms(); else noTerms">
                      <ng-container *ngIf="element.distribution_case_terms?.length > 0; else noDistributionTerms">
                        <ng-container *ngFor="let term of element.distribution_case_terms">
                          <ng-container *ngIf="hasMatchingCreditor(term); else noMatchingCreditor">
                            <!-- Loop over creditors and create one row per creditor -->
                            <ng-container *ngFor="let creditor of getUniqueCreditors(term)">
                              <ng-container
                                *ngIf="term.batches.name === creditor.name && !excludedProductId.includes(creditor.pivot.product_id)">
                                <tr>
                                  <td>{{ creditor.name }}
                                    <ng-container *ngIf="hasMismatch(term)">
                                      <div>
                                        *Mismatch found
                                        <br>
                                        Case offer to Creditor: {{ creditor.pivot.offer_to_creditor | number:'1.2-2' }}
                                        €
                                        <br>
                                        Amount to Distribute: {{ term.amount_to_distribute | number:'1.2-2' }} €
                                      </div>
                                    </ng-container>
                                  </td>
                                  <td>
                                    <span>
                                      {{
                                        term.amount_distributed != null &&
                                        element.name.includes('Phase 2') ?
                                          (term.amount_distributed | number:'1.2-2') + ' € ' : ''
                                      }}
                                      <!-- &&
                                        (term.amount_distributed <= term.amount_to_distribute)
                                        {{
                                        term.amount_distributed != null &&
                                        element.name.includes('Phase 2') &&
                                        (term?.amount_distributed > term.amount_to_distribute) ?
                                          (term.amount_to_distribute | number:'1.2-2') + ' € ' : ''
                                        }}
                                      -->
                                      /
                                      {{ term.amount_to_distribute != null ? (term.amount_to_distribute | number:'1.2-2') + ' €' : 'N/A' }}
                                    </span>
                                  </td>
                                  <td>
                                    <ng-container
                                      *ngIf="term && term.hold_distribution && (term.amount == term.amount_paid)">
                                      {{ term.amount_to_distribute | number:'1.2-2' }} €
                                    </ng-container>
                                    <ng-container
                                      *ngIf="term && term.hold_distribution && !(term.amount == term.amount_paid)">
                                      {{ term.amount_to_distribute | number:'1.2-2' }} €
                                    </ng-container>
                                    <ng-container *ngIf="!(term && term.hold_distribution)">
                                      <ng-container *ngIf="creditor?.pivot?.product_id === 15 &&
                                                            (creditor?.pivot?.case_creditor_status_id === 4 ||
                                                            creditor?.pivot?.case_creditor_status_id === 35)">
                                        yes
                                      </ng-container>
                                      <ng-container *ngIf="!(creditor?.pivot?.product_id === 15 &&
                                                              (creditor?.pivot?.case_creditor_status_id === 4 ||
                                                                creditor?.pivot?.case_creditor_status_id === 35))">
                                        no
                                      </ng-container>
                                    </ng-container>
                                  </td>
                                </tr>
                              </ng-container>
                            </ng-container>
                          </ng-container>

                          <!-- Template for no matching creditors -->
                          <ng-template #noMatchingCreditor>
                            <ng-container *ngIf="isBatchIncluded(term, element)">
                              <tr>
                                <td>{{ term.batches.name }}</td>
                                <td>
                                  {{ term.amount_distributed | number:'1.2-2' }} € /
                                  {{ term.amount_to_distribute | number:'1.2-2' }}
                                </td>
                                <td>
                                  <ng-container *ngIf="term.hold_distribution; else noConditionMet">
                                    yes
                                  </ng-container>
                                  <ng-template #noConditionMet>
                                    no
                                  </ng-template>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <ng-template #noDistributionTerms>
                      <p>Distribution plan does not match the case plan</p>
                    </ng-template>

                    <!-- Fallback to old logic -->
                    <ng-template #noTerms>
                      <ng-container *ngFor="let creditor of case.unsecured_creditors">
                        <ng-container *ngIf="!excludedProductId.includes(creditor.pivot.product_id)">
                          <tr>

                            <!--<ng-container *ngIf="isUnfifyePlan(element, creditor); else unifyPlan">
                              <td>{{ creditor.name }}</td>
                            </ng-container>
                            <ng-template #unifyPlan>
                              <td>UNIFYE Plan</td>
                            </ng-template>-->

                            <ng-container *ngIf="isUnfifyePlan(element, creditor);">
                              <td>{{ creditor.name }}</td>
                              <td *ngIf="!isMatchingFinalPhase(element.name, creditor.pivot.terms)">
                                0 {{ creditor?.pivot?.offer_to_creditor != null ? ' / ' + (creditor.pivot.offer_to_creditor | number:'1.2-2') + ' €' : 'N/A' }}
                              </td>
                              <td *ngIf="isMatchingFinalPhase(element.name, creditor.pivot.terms)">
                                0 {{ creditor?.pivot?.final_payment != null ? ' / ' + (creditor.pivot.final_payment | number:'1.2-2') + ' €' : 'N/A' }}
                              </td>
                              <td>
                                {{
                                  creditor?.pivot?.product_id === 15 &&
                                  (creditor?.pivot?.case_creditor_status_id === 4 ||
                                    creditor?.pivot?.case_creditor_status_id === 35) ?
                                    '0 / ' + (creditor.pivot.offer_to_creditor | number:'1.2-2') + ' €' : 'no'
                                }}
                              </td>
                            </ng-container>
                          </tr>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="calculateSumsByPhase(element, case.creditors).matchingPhaseSum > 0">
                        <tr>
                          <td>UNIFYE PLAN</td>
                          <td>
                            0 / {{
                              calculateSumsByPhase(element, case.unsecured_creditors).matchingPhaseSum
                                | number:'1.2-2'
                            }} €
                          </td>
                          <td>
                            no
                          </td>
                        </tr>
                      </ng-container>
                    </ng-template>

                    </tbody>
                  </table>
                </div>

              </ng-container>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
            [ngClass]="'custom-row'"
            [class.example-expanded-row]="expandedElement === element"
            [class.example-expandeds-row]="expandedElementDS === element"
            (click)="isProductDS ? (expandedElementDS = expandedElementDS === element ? null : element) : '';">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetailDS">
          <td mat-cell *matCellDef="let parentElement" [attr.colspan]="displayedColumns.length">
            <div class="element-detailds"
                 [@detailExpandDS]="parentElement === expandedElementDS ? 'expanded' : 'collapsed'">
              <!--Second table-->
              <div class="card-body p-0">
                <div style="border: 1px solid rgba(0, 0, 0, 0.12); ">
                  <table style="width: 100%" mat-table matSort (matSortChange)="sortData($event)"
                         [dataSource]="parentElement.child_installments_source">

                    <ng-container matColumnDef="next-payment">
                      <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.payment-schedule" | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        <div *ngIf="element.active">
                          <span>{{ element.term_date | toDateObject | date }}</span>
                          <p class="m-0" style="color: red"
                             *ngIf="element.amount_paid < element.amount && (element.term_date | toDateObject) < now">
                            <small>{{ "PAYMENTS.missed_payment" | translate }}</small>
                          </p>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="date-paid">
                      <th mat-header-cell
                          *matHeaderCellDef>{{ "DISTRIBUTION.installments.dist_date_paid" | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element"> {{ element.date_paid | toDateObject | date }}
                        <ng-container *ngIf="element.date_paid">
                          <p class="m-0" style="color: green" *ngIf="element.amount_paid === element.amount">
                            <small>{{ "PAYMENTS.paid" | translate }}</small>
                          </p>
                          <p class="m-0" style="color: orange"
                             *ngIf="element.amount_paid < element.amount && element.amount_paid > 0">
                            <small>{{ "PAYMENTS.partial-paid" | translate }}</small>
                          </p>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                      <th mat-header-cell *matHeaderCellDef>{{ "PAYMENTS.amount" | translate }}</th>
                      <td mat-cell *matCellDef="let childElement">
                        <small class="font-weight-lighter">{{ +childElement.amount_paid | number: '1.2-2' }}€
                          / {{ +childElement.amount | number: '1.2-2' }}€ </small>
                        <span
                          class="fw-bold">- {{ +(childElement.amount) - +(childElement.amount_paid) | number: '1.2-2' }}
                          €</span>
                        <div class="progress" style="max-width: 120px">
                          <div class="progress-bar progress-bar-striped" role="progressbar"
                               [style]="{width: getPercent(childElement?.amount_paid, childElement?.amount)  + '%'}"
                               [attr.aria-valuenow]="getPercent(childElement?.amount_paid, childElement?.amount)"
                               [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">{{
                              getPercent(childElement?.amount_paid,
                                childElement?.amount)
                            }}%
                          </div>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "PAYMENTS.label" | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.case_payment_plan.type.name }}<br>
                        {{ element.name }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>{{ "SHARED.actions" | translate }}</th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-stroked-button [matMenuTriggerFor]="childInstallmentMenu">
                          {{ "SHARED.actions" | translate }}
                        </button>
                        <mat-menu #childInstallmentMenu="matMenu">
                          <button mat-menu-item class="dropdown-item clickable"
                                  [disabled]="element.case_payment_plan.type.slug !== 'negotiation_fee' || element.amount_paid > 0"
                                  (click)="deleteChildInstallment(element.id, parentElement)">
                            {{ 'CASES.single.payments.installment_list.table.actions.delete' | translate }}
                          </button>
                        </mat-menu>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsChildInstallments"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsChildInstallments;"></tr>
                  </table>

                  <div *ngIf="isLoading" class="text-center" style="padding: 50px">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div
                    *ngIf="!isLoading && parentElement.child_installments_source && parentElement.child_installments_source.data.length < 1"
                    style="padding: 50px">
                    <h3 class="text-center">{{ "PAYMENTS.no-payments" | translate }}</h3>
                  </div>

                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetailDS']" class="example-detailds-row"></tr>
      </table>

      <div *ngIf="isLoading" class="text-center" style="padding: 50px">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div *ngIf="!isLoading && dataSource && dataSource.data.length < 1" style="padding: 50px">
        <h3 class="text-center">{{ "PAYMENTS.no-payments" | translate }}</h3>
      </div>

      <mat-paginator
        [length]="paginatorConfig.length"
        [pageSize]="paginatorConfig.pageSize"
        [pageSizeOptions]="[5, 10, 20, 25]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
